import FormatService from './format';

function formatAmount(amount) {
  if (typeof amount === 'undefined') {
    return '';
  }
  if (amount < 0) {
    return '- ' + FormatService.formatCentsToCurrency(amount, true).replace('-', '');
  } else {
    return FormatService.formatCentsToCurrency(amount, true);
  }
}
export default formatAmount;
